import type { RootState } from "~/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GridRefreshState {
	requestedAt: Record<string, number>;
}

const initialState: GridRefreshState = {
	requestedAt: {}
};

export const gridRefreshSlice = createSlice({
	initialState,
	name: "gridRefresh",
	reducers: {
		requestGridRefresh: (state, action: PayloadAction<string>) => {
			state.requestedAt[action.payload] = Date.now();
		}
	}
});

export const { requestGridRefresh } = gridRefreshSlice.actions;

export const selectGridRefreshRequestedAt =
	(gridId: string) =>
	(state: RootState): number | undefined =>
		state.gridRefresh?.requestedAt[gridId];

export default gridRefreshSlice.reducer;
